import React from 'react';
import { Spinner } from '../../components/ui';
import { INVITE_STATUSES, inviteChipClass, sideChipClass, fullName } from '../../utils/helpers';

// Desktop UI for Mark Status — grouped tables with quick-move buttons.
export default function StatusDesktop({ vm }) {
  const { isAdmin, canEdit, mine, rows, loading, grouped, mark } = vm;
  return (
    <div>
      <div className="page-head"><h1>Mark Status</h1><span className="muted">{rows.length}</span></div>
      <div className="muted" style={{ marginBottom: 12, fontSize: 13 }}>
        {isAdmin ? 'All members across the event.' : 'The members you added.'} Use the buttons to mark each as Invited, Confirmed or Declined.
      </div>

      {loading ? <Spinner /> : rows.length === 0 ? (
        <div className="card card-pad empty">No members yet.</div>
      ) : (
        <div style={{ display: 'grid', gap: 16 }}>
          {INVITE_STATUSES.map(status => (
            <div key={status} className="card card-pad">
              <h3 style={{ margin: '0 0 10px', display: 'flex', alignItems: 'center', gap: 8 }}>
                <span className={inviteChipClass(status)}>{status}</span>
                <span className="muted" style={{ fontSize: 13, fontWeight: 400 }}>{grouped[status].length}</span>
              </h3>
              {grouped[status].length === 0 ? <div className="muted" style={{ fontSize: 13 }}>None.</div> : (
                <div className="table-wrap">
                  <table className="tbl">
                    <tbody>
                      {grouped[status].map(row => (
                        <tr key={row.GuestId}>
                          <td>{fullName(row)}</td>
                          <td>{row.MobileNumber || '—'}</td>
                          <td>{row.FunctionName || '—'}</td>
                          <td><span className={sideChipClass(row.Side)}>{row.Side}</span></td>
                          {isAdmin && <td>{(row.AddedByName || row.InvitedByName || '').trim() || '—'}</td>}
                          {canEdit && (
                            <td style={{ textAlign: 'right' }}>
                              {mine(row)
                                ? INVITE_STATUSES.filter(s => s !== status).map(s => (
                                    <button key={s} className="btn light sm" style={{ marginLeft: 6 }} onClick={() => mark(row, s)}>{s}</button>
                                  ))
                                : <span className="muted" style={{ fontSize: 12 }}>shared</span>}
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
